import { render, staticRenderFns } from "./newPage4.vue?vue&type=template&id=138f38be&scoped=true"
import script from "./newPage4.vue?vue&type=script&lang=js"
export * from "./newPage4.vue?vue&type=script&lang=js"
import style0 from "./newPage4.vue?vue&type=style&index=0&id=138f38be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138f38be",
  null
  
)

export default component.exports